import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ActionSheetController } from 'ionic-angular';
import { UiProvider } from '../ui/ui';


@Injectable()
export class UiPhotoLibraryProvider {

	private loader: any;
	private cameraOption: CameraOptions = {
		correctOrientation: true,
		destinationType: this.camera.DestinationType.DATA_URL,
		allowEdit: true,
		encodingType: this.camera.EncodingType.JPEG,
		quality: 25,
		saveToPhotoAlbum: false,
		mediaType: this.camera.MediaType.PICTURE,
		targetWidth: 600,
		targetHeight: 600
	}

	constructor(
		private camera: Camera,
		private actionSheetCtrl: ActionSheetController,
		private uiProvider: UiProvider
	) { }


	/**
	 *
	 *
	 * @param {CameraOptions} [newOption={}]
	 * @returns
	 * @memberof UiPhotoLibraryProvider
	 * 
	 * This @method getPictureUrl() is used to get image as `url` 
	 * 
	 */

	public getPictureUrl(newOption: CameraOptions = {}) {

		return new Promise((resolve, reject) => {

			let option = {
				...this.cameraOption,
				...newOption
			};

			option.destinationType = this.camera.DestinationType.FILE_URI;

			option.sourceType = this.camera.PictureSourceType.CAMERA;
			option.encodingType = this.camera.EncodingType.JPEG;
				// this.retrieveUrl(option, resolve, reject);

			/** 
			 *  If want to give user a option for select image or get image from device storage.
			 *  Then uncomment following code and comment above 2 lines code..
			 * 
			 *  	option.sourceType = this.camera.PictureSourceType.CAMERA;
			 *  	this.retrieveUrl(option, resolve, reject);
			 * 
			 */


			const actionSheet = this.actionSheetCtrl.create({
				title: 'Select Image',
				cssClass: 'action-sheet action-sheet--photo-library',
				buttons: [{
					text: 'Take Photo',
					handler: () => {
						option.sourceType = this.camera.PictureSourceType.CAMERA,
							this.retrieveUrl(option, resolve, reject);
					}
				}, {
					text: 'Choose from Gallery',
					handler: () => {
						option.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
						this.retrieveUrl(option, resolve, reject);
					}
				}, {
					text: 'Cancel',
					role: 'cancel',
					handler: () => {
						reject("Please select image.");
					}
				}]
			});
			actionSheet.present();

		});



	}

	/**
	 *
	 *
	 * @returns
	 * @memberof UiPhotoLibraryProvider
	 * 
	 * This @method getPicture() is used for get image as `base64String`
	 */

	public getPicture() {

		this.cameraOption.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;

		return new Promise((resolve, reject) => {
			const actionSheet = this.actionSheetCtrl.create({
				title: 'Select Image',
				cssClass: 'action-sheet action-sheet--photo-library',
				buttons: [{
					text: 'Take Photo',
					handler: () => {
						this.cameraOption.sourceType = this.camera.PictureSourceType.CAMERA,
							this.retrieve(this.cameraOption, resolve, reject);
					}
				}, {
					text: 'Choose from Gallery',
					handler: () => {
						this.cameraOption.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
						this.retrieve(this.cameraOption, resolve, reject);
					}
				}, {
					text: 'Cancel',
					role: 'cancel',
					handler: () => {
						reject("Please select image.");
					}
				}]
			});
			actionSheet.present();

		
				// this.retrieve(this.cameraOption, resolve, reject);

		});
	}

	private retrieveUrl(cameraOption, resolve, reject) {
		this.loader = this.uiProvider.getLoader();
		this.loader.present();
		this.camera.getPicture(cameraOption).then((imageData) => {
			this.loader.dismiss();
			resolve(imageData);
		}, (err) => {
			this.loader.dismiss();
			reject(err);
		});
	}

	private retrieve(cameraOption, resolve, reject) {

		this.loader = this.uiProvider.getLoader();
		this.loader.present();
		this.camera.getPicture(cameraOption).then((imageData) => {
			this.loader.dismiss();
			resolve('data:image/jpeg;base64,' + imageData);
		}, (err) => {
			this.loader.dismiss();
			reject(err);
		});

	}

}




// WEBPACK FOOTER //
// ./src/providers/ui-photo-library/ui-photo-library.ts